import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mono-common-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  public dateObject = Date.now();

  constructor() { }

  ngOnInit(): void {
  }
}
